import React from 'react';

export function SEO({ title, description, path = "" }) {
  const siteUrl = "https://vejentilbarnet.dk"; // Primære domæne
  const fullUrl = `${siteUrl}${path}`;
  const defaultImage = "https://assets.auxodev.dk/assets/eff3456d-e9a8-4cc4-936d-27bf51e95b8f/47f26c9d-0f3c-41b8-a3e3-33153b18a220.png";

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook / LinkedIn */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={defaultImage} />
      <meta property="og:locale" content="da_DK" />
      <meta property="og:site_name" content="Vejen til barnet" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={defaultImage} />

      {/* Canonical Link */}
      <link rel="canonical" href={fullUrl} />
    </>
  );
}
